const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  staff: yup.string().required("Name is required"),
  page: yup.string().required("Page is required"),
});

module.exports = {
  create,
};
